export enum Domains {
  FLOWCODE = 'flowcode',
  FLOWPAGE = 'flowpage'
}
